// extracted by mini-css-extract-plugin
export default {"container":"Badges_container__MtRsG","wrapper":"Badges_wrapper__0hNSz","labelWrapper":"Badges_labelWrapper__Yjf4z"};